 /* global document:true */

import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, browserHistory, IndexRoute } from 'react-router';
import { Provider } from 'react-redux';
import ReactGA from 'react-ga';
import lockr from 'lockr';

import './styles/style.css';
import App from './containers/App';
import Login from './containers/Login';
import Register from './containers/Register';
import ForgetPassword from './containers/ForgetPassword';
import Dashboard from './containers/Dashboard';
import About from './containers/About';
import Contact from './containers/Contact';
import BookSession from './containers/BookSession';
import NotFound from './pages/NotFound';
import ResourcesWrapper from './components/ResourcesWrapper';
import ResourcesList from './containers/ResourcesList';
import ResourceView from './containers/ResourceView';
import ResourceManage from './containers/ResourceManage';
import Shop from './containers/Shop';
import AddUsers from './containers/AddUsers';
import ProfileUpdate from './containers/ProfileUpdate';
import ProfileSettings from './containers/ProfileSettings';
import Charts from './containers/Charts';
import SchoolRejected from './pages/SchoolRejected';
import SchoolPending from './pages/SchoolPending';
import UserNotActive from './pages/UserNotActive';
import Invite from './containers/Invite';

/**
 * ## Actions
 *  The necessary actions for dispatching our bootstrap values
 */
import { setVersion } from './core/global/globalActions';

/**
 *  The version of the app but not displayed yet
 */
import pack from '../package.json';

/**
 * ### configureStore
 */
import configureStore from './core/store';

// load CONSTATNS
const {
    GOOGLE_ANALYTICS_ID,
    DEBUG
} = require('./core/constants').default;

const store = configureStore({});

const VERSION = pack.version;

store.dispatch(setVersion(VERSION));

// load google analytics
ReactGA.initialize(GOOGLE_ANALYTICS_ID, { debug: DEBUG });

function requireAuth(nextState, replace) {
    if (!lockr.get('clevertykes-key')) {
        replace({
            pathname: '/login',
            state: { nextPathname: nextState.location.pathname }
        });
    }
}

ReactDOM.render(
    <Provider store={store}>
        <Router history={browserHistory}>
            <Route path="/" component={App}>
                <IndexRoute component={Dashboard} onEnter={requireAuth} />
                <Route path="login" component={Login} />
                <Route path="register" component={Register} />
                <Route path="forget-password" component={ForgetPassword} />
                <Route path="resources" component={ResourcesWrapper} onEnter={requireAuth}>
                    <IndexRoute component={ResourcesList} />
                    <Route path="view/:resourceId" component={ResourceView} />
                    <Route path="manage" component={ResourceManage} />
                </Route>
                <Route path="shop" component={Shop} onEnter={requireAuth} />
                <Route path="charts" component={Charts} />
                <Route path="about" component={About} />
                <Route path="contact" component={Contact} />
                <Route path="book-session" component={BookSession} onEnter={requireAuth} />
                <Route path="add-users" component={AddUsers} onEnter={requireAuth} />
                <Route path="profile" onEnter={requireAuth}>
                    <Route path="update" component={ProfileUpdate} />
                    <Route path="settings" component={ProfileSettings} />
                </Route>
                <Route path="invite" component={Invite} onEnter={requireAuth} />
                <Route path="school-rejected" component={SchoolRejected} />
                <Route path="school-rejected" component={SchoolPending} />
                <Route path="not-active" component={UserNotActive} />
                <Route path="*" component={NotFound} />
            </Route>
        </Router>
    </Provider>,
    document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/